<template>
  <div name="molecule-create-edit-contract-note" class="contract-note-card">
    <div class="card__header">
      <span class="card__header--topic">Contract Notes</span>
    </div>
    <label v-if="checkDisableInput() && !contractNoteList.length">
      No Contract Note.
    </label>
    <div
      class="note-card mt-2"
      v-for="note in contractNoteList"
      :key="note.contractNoteId"
    >
      <div class="created-by">{{ note.createdBy }}</div>
      <div class="created-at">{{ formatDateTime(note.createdAt) }}</div>
      <div
        v-if="!isContractInDeletedStatus && hasEditPermission"
        class="delete-icon"
        @click="onClickDeleteNote(note.contractNoteId)"
      >
        <feather-icon
          icon="Trash2Icon"
          size="18"
          stroke="#ea5455"
        ></feather-icon>
      </div>
      <div class="note-content">
        {{ note.note }}
      </div>
    </div>
    <div
      v-if="!isContractInDeletedStatus && !isAddingNewNote && hasEditPermission"
      class="button-wrapper"
    >
      <div class="button-dash box-dashed" @click="onClickAddNoteButton">
        <feather-icon
          class="icon-size-24px text-primary"
          icon="PlusCircleIcon"
        ></feather-icon>
        <label class="button--text">Add Note</label>
      </div>
    </div>
    <div v-else-if="isAddingNewNote" class="new-note-textbox-wrapper mt-2">
      <atom-text-area
        v-model="newNoteData"
        placeholder="New Contract Note"
        errorMessage="Note cannot be blank"
        :rows="3"
        :isError="isErrorNewNoteDataEmpty"
      >
      </atom-text-area>
      <div
        class="button-new-note mt-1 d-flex justify-content-end align-items-end"
      >
        <atom-button
          buttonId="confirm-add-new-note"
          :isOnlyIcon="true"
          iconLeft="CheckIcon"
          @click="onClickAddNewNote"
        ></atom-button>
        <atom-button
          buttonId="cancel-add-new-note"
          class="ml-1"
          :isOnlyIcon="true"
          iconLeft="XIcon"
          buttonStyle="border"
          buttonColor="secondary"
          @click="onClickCancelAddNewNote"
        ></atom-button>
      </div>
    </div>
    <!-- start modal section -->
    <!-- start modal add note -->
    <molecule-modal-dialog
      modalId="modal-confirm-add-new-note"
      :icon="hasChangeValue ? 'AlertCircleIcon' : undefined"
      :isTextCenter="true"
      textTitle="Do you want to add new note?"
      :textSubtitle="hasChangeValue ? 'There are some contract detail changes\nit will be discard after add note': ''"
      buttonTextLeft="Confirm"
      @clickButtonLeft="onClickConfirmAddNewNoteFromModal"
    ></molecule-modal-dialog>
    <!-- end modal add note -->

    <!-- start modal delete note -->
    <molecule-modal-dialog
      modalId="modal-confirm-delete-note"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete?"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      :isTextCenter="true"
      @clickButtonLeft="onClickConfirmDeleteNoteFromModal"
    >
    </molecule-modal-dialog>
    <!-- end modal delete note -->

    <!-- start modal confirm add note -->
    <molecule-modal-dialog
      modalId="modal-has-change-before-update-note"
      textTitle="Do you want to save changes before ?"
      :textSubtitle="`There are some contract detail changes\nit will be discard after update note`"
      buttonTextLeft="Save Changes"
      buttonTextRight="Update Note"
      :isTextCenter="true"
      @clickButtonLeft="onClickSaveChangeBeforeUpdateNote"
      @clickButtonRight="onClickUpdateNoteWithoutSaveChanges"
      @clickIconClose="closeModal()"
    >
    </molecule-modal-dialog>
    <!-- end modal confirm add note -->
    <!-- end modal section -->
  </div>
</template>

<script>
import { DateTime } from "luxon"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
export default {
  name: "MoleculeCreateEditContractNote",
  mixins: [mixinsValidator],
  components: { AtomButton, AtomTextArea, MoleculeModalDialog },
  props: {
    contractNoteList: {
      type: Array,
      required: false,
      default: () => [],
    },
    contractStatus: {
      type: String,
      required: false,
      default: "",
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasChange: {
      type: Boolean,
      required: true,
    },
    isErrorOccur: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      modalId: null,
      validateNewNoteTrigger: false,
      isAddingNewNote: false,
      newNoteData: "",
      targetNoteId: null,
    }
  },
  computed: {
    isContractInDeletedStatus() {
      return this.contractStatus?.toLowerCase() === "deleted"
    },
    isErrorNewNoteDataEmpty() {
      return this.validateNewNoteTrigger
        ? this.isEmptyString(this.newNoteData)
        : false
    },
    hasChangeValue: {
      get() {
        return this.hasChange
      },
    },
  },
  methods: {
    formatDateTime(datetime) {
      return DateTime.fromISO(datetime).toFormat("dd/MM/yyyy HH:mm")
    },
    setNewNoteDataToDefault() {
      this.newNoteData = ""
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    onClickAddNoteButton() {
      if (this.hasChangeValue) {
        this.modalId = "modal-has-change-before-update-note"
        this.$bvModal.show(this.modalId)
      } else {
        this.isAddingNewNote = true
      }
    },
    onClickSaveChangeBeforeUpdateNote() {
      this.$emit("onRequestSaveChangesContract")

      if (this.isErrorOccur) {
        this.closeModal()
      } else {
        this.closeModal()
        
        if (this.targetNoteId) {
          this.modalId = "modal-confirm-delete-note"
          this.$bvModal.show(this.modalId)
        } else {
          this.isAddingNewNote = true
        }
      }
    },
    onClickUpdateNoteWithoutSaveChanges() {
      this.closeModal()

      if (this.targetNoteId) {
        this.modalId = "modal-confirm-delete-note"
        this.$bvModal.show(this.modalId)
      } else {
        this.isAddingNewNote = true
      }
    },
    onClickDeleteNote(noteId) {
      if (this.hasChangeValue) {
        this.modalId = "modal-has-change-before-update-note"
        this.$bvModal.show(this.modalId)
      } else {
        this.modalId = "modal-confirm-delete-note"
        this.$bvModal.show(this.modalId)
      }

      this.targetNoteId = noteId
    },
    onClickConfirmDeleteNoteFromModal() {
      const contractId = this.$route?.params?.id.replace(/\D/g, "")
      this.$emit("onRequestDeleteNote", contractId, this.targetNoteId)
      this.closeModal()
      this.targetNoteId = null
    },
    onClickAddNewNote() {
      this.targetNoteId = null
      this.validateNewNoteTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorNewNoteDataEmpty) {
          this.modalId = "modal-confirm-add-new-note"
          this.$bvModal.show(this.modalId)
        }
      })
    },
    onClickConfirmAddNewNoteFromModal() {
      const contractId = this.$route?.params?.id.replace(/\D/g, "")
      this.$emit("onRequestAddNewNote", contractId, this.newNoteData)
      this.closeModal()
      this.isAddingNewNote = false
      this.setNewNoteDataToDefault()
      this.validateNewNoteTrigger = false
    },
    onClickCancelAddNewNote() {
      this.isAddingNewNote = false
      this.setNewNoteDataToDefault()
      this.validateNewNoteTrigger = false
    },
    checkDisableInput(condition = false) {
      const booleanCondition = Boolean(condition)
      return (
        !this.hasEditPermission ||
        this.isContractInDeletedStatus ||
        booleanCondition
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-note-card {
  padding: 21px;
}

.card__header {
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.note-card {
  display: grid;
  grid-template-areas:
    " created-by created-at delete-icon"
    " note-content note-content delete-icon";
  grid-template-columns: auto 120px 50px;
  grid-gap: 6px;
  padding: 12px;
  border: 1px solid #ebe9f1;
  border-radius: 5px;
  width: 100%;
}

.created-by {
  grid-area: created-by;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
}

.created-at {
  grid-area: created-at;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
}

.delete-icon {
  grid-area: delete-icon;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fceaeb;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  &:hover {
    cursor: pointer;
  }
}

.note-content {
  grid-area: note-content;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
}

.button-dash {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new-note-textbox-wrapper,
.button-new-note {
  width: 300px;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.button-wrapper,
.note-card,
.new-note-textbox-wrapper,
.button-new-note {
  max-width: 550px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .button-wrapper,
  .note-card,
  .new-note-textbox-wrapper,
  .button-new-note {
    width: 550px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}
</style>
